import { useStateQueryParams } from 'app/common/hooks/useStateQueryParams';

import { BusinessModalQueryParams } from '../../helpers/queryParams';

export const useOrgsQueryParams = () => {
    const [org_id, setOrgId] = useStateQueryParams(BusinessModalQueryParams.OrgId);
    return {
        org_id,
        setOrgId,
    };
};
